export interface ShortcutEntry {
  group: string;
  keys: string;
  label: string;
}

export const SHORTCUTS: ShortcutEntry[] = [
  { group: 'Issue actions', keys: 'C', label: 'New issue' },
  { group: 'Issue actions', keys: 'S', label: 'Status' },
  { group: 'Issue actions', keys: 'A', label: 'Assignee' },
  { group: 'Issue actions', keys: 'P', label: 'Priority' },
  { group: 'Issue actions', keys: 'I', label: 'Assign to me' },
  { group: 'Issue actions', keys: 'L', label: 'Labels' },
  { group: 'Issue actions', keys: 'Shift+0–4', label: 'Set priority' },
  { group: 'Issue actions', keys: 'Space', label: 'Peek' },
  { group: 'Issue actions', keys: 'Enter', label: 'Open' },
  { group: 'Issue actions', keys: '⌘⇧.', label: 'Copy identifier' },
  { group: 'Navigation', keys: 'G I', label: 'Inbox' },
  { group: 'Navigation', keys: 'G M', label: 'My issues' },
  { group: 'Navigation', keys: 'G A', label: 'Active' },
  { group: 'Navigation', keys: 'G B', label: 'Backlog' },
  { group: 'Navigation', keys: 'G E', label: 'All issues' },
  { group: 'Navigation', keys: 'G P', label: 'Projects' },
  { group: 'Navigation', keys: 'G T', label: 'Teams' },
  { group: 'Navigation', keys: 'G C', label: 'Cycles' },
  { group: 'Navigation', keys: 'G V', label: 'Views' },
  { group: 'Navigation', keys: 'G S', label: 'Settings' },
  { group: 'Navigation', keys: 'G R', label: 'Reviews' },
  { group: 'Navigation', keys: 'G D', label: 'Documents' },
  { group: 'Layout', keys: '⌘K', label: 'Command menu' },
  { group: 'Layout', keys: '⌘B', label: 'Toggle board' },
  { group: 'Layout', keys: 'F', label: 'Filter' },
  { group: 'Layout', keys: '?', label: 'Keyboard shortcuts' },
  { group: 'Layout', keys: 'J / K', label: 'Move selection' },
];
